import {AppButtonIcon} from "@components"
import {ANALYZERS_ROUTES, FEATURES_TYPE, ONE_WAY_ROUTES} from "@constants"
import {Box} from "@mui/material"
import {useSignal} from "@preact/signals-react"
import {reports, reportsInfo, userData} from "@signals"
import React, {useEffect} from "react"
import {useSearchParams} from "react-router-dom"
import { dsColorNew } from "@palette"


export default function PageWrapperAnalyzers() {
	const selectedReport = useSignal(false)
	const location = window.location.pathname
	const [ searchParams ] = useSearchParams()
	const hasDirectSites = useSignal(false)
	const hasCompetitionSites = useSignal(false)
	const searchID = searchParams.get("idSearch")
	const urlId = !!searchID ? `idSearch=${searchID}` : `idReportExecution=${reports.value}`
	const additionalParams = `&hasDirectSites=${hasDirectSites.value}&hasCompetitionSites=${hasCompetitionSites.value}`

	useEffect(() => {
		selectedReport.value = reportsInfo.value.find(({ value }) => reports.value === value)
		hasDirectSites.value = selectedReport.value?.hasDirectSites || ( !!searchParams.get("hasDirectSites") && searchParams.get("hasDirectSites") !== "false")
		hasCompetitionSites.value = selectedReport.value?.hasCompetitionSites || ( !!searchParams.get("hasCompetitionSites") && searchParams.get("hasCompetitionSites") !== "false")
	}, [ reports.value, location, reportsInfo.value ])
	if ( !selectedReport.value && !searchID) return null


	return <Box data-tour-id="tour-analyzer-links" sx={{
		display: "flex",
		alignItems: "center",
		justifyContent: "space-evenly",
		gap: 1,
	}}>
		{ !location.includes("lor") && (
			<AppButtonIcon
				onClick={() => {
					window.open(`${ANALYZERS_ROUTES.LOR_PATH}?${urlId}${additionalParams}`, "_blank")
				}}
				onAuxClick={(e) => {
					if (e.button === 1) {
						window.open(`${ANALYZERS_ROUTES.LOR_PATH}?${urlId}${additionalParams}`)
					}
					e.preventDefault()
				}}
				icon="tally"
				tooltip="LOR Analyzer"
			/>
		)}

		{ !location.includes("dor") && (
			<AppButtonIcon
				icon="calendar-days"
				tooltip="DOR Analyzer"
				sx={{ color: dsColorNew.appBlue }}
				onClick={() => {
					window.open(`${ANALYZERS_ROUTES.DOR_PATH}?${urlId}${additionalParams}`, "_blank")
				}}
				onAuxClick={(e) => {
					if (e.button === 1) {
						window.open(`${ANALYZERS_ROUTES.DOR_PATH}?${urlId}${additionalParams}`)
					}
					e.preventDefault()
				}}
			/>
		)}


		{( !location.includes("direct-site") && !!hasDirectSites.value) && <AppButtonIcon
			icon="chart-line"
			tooltip="Direct Site Analyzer"
			sx={{ color: dsColorNew.successText }}
			onClick={() => {
				window.open(`${ANALYZERS_ROUTES.DIRECT_SITE_PATH}?${urlId}${additionalParams}`, "_blank")
			}}
			onAuxClick={(e) => {
				if (e.button === 1) {
					window.open(`${ANALYZERS_ROUTES.DIRECT_SITE_PATH}?${urlId}${additionalParams}`)
				}
				e.preventDefault()
			}}
		/>}

		{( !location.includes("brokers") && !!hasCompetitionSites.value) && <AppButtonIcon
			icon="handshake"
			tooltip="Brokers Analyzer"
			sx={{ color: dsColorNew.noteAmber }}
			onClick={() => {
				window.open(`${ANALYZERS_ROUTES.BROKERS_PATH}?${urlId}${additionalParams}`, "_blank")
			}}
			onAuxClick={(e) => {
				if (e.button === 1) {
					window.open(`${ANALYZERS_ROUTES.BROKERS_PATH}?${urlId}${additionalParams}`)
				}
				e.preventDefault()
			}}
		/>}

		{( !location.includes("rating") && !!hasCompetitionSites.value) && <AppButtonIcon
			onClick={() => {
				window.open(`${ANALYZERS_ROUTES.RATING_PATH}?${urlId}${additionalParams}`, "_blank")
			}}
			onAuxClick={e => {
				if (e.button === 1) {
					window.open(`${ANALYZERS_ROUTES.RATING_PATH}?${urlId}${additionalParams}`)
				}
				e.preventDefault()
			}}
			icon="star"
			tooltip="Rating Analyzer"
			sx={{ color: dsColorNew.noteAmber }}
		/>}

		{ !location.includes("position") && (
			<AppButtonIcon
				onClick={() => {
					window.open(`${ANALYZERS_ROUTES.POSITION_PATH}?${urlId}${additionalParams}`, "_blank")
				}}
				onAuxClick={e => {
					if (e.button === 1) {
						window.open(`${ANALYZERS_ROUTES.POSITION_PATH}?${urlId}${additionalParams}`)
					}
					e.preventDefault()
				}}
				icon="ranking-star"
				tooltip="Rank Analyzer"
				sx={{ color: "secondary.main" }}
			/>
		)}

		{/* only with One Way: without it `/one-way/*` is not routed and the button led to the 404 (CU-869fmherf) */}
		{ !location.includes("one-way") && !!userData.value?.featuresV2?.[FEATURES_TYPE.ONE_WAY] && (
			<AppButtonIcon
				onClick={() => {
					window.open(`${ONE_WAY_ROUTES.ANALYZER_PATH}?${urlId}${additionalParams}`, "_blank")
				}}
				onAuxClick={e => {
					if (e.button === 1) {
						window.open(`${ONE_WAY_ROUTES.ANALYZER_PATH}?${urlId}${additionalParams}`)
					}
					e.preventDefault()
				}}
				icon="arrow-right-arrow-left"
				tooltip="One Way Analyzer"
				sx={{ color: "success.dark" }}
			/>
		)}
	</Box>
}